<div class="card1" (click)="onCardClick()">
    <div class="fw-bolder d-flex flex-column align-items-start me-3">
        <img src="{{partner.logo}}" class="mb-2 rounded" style="width: 3rem; height: auto;" alt="">
    </div>

    <div class="partnerdets">
        <h5>{{partner.org}}</h5>
        <p *ngIf="partner.servicesOffered.length > 0;else no_services"
            class="partnersFilterInfo fw-normal">
            <b>Services: </b>{{partner.servicesOffered.join(', ')}}<br>
            <b>Focus Areas: </b>{{partner.focusAreas.join(', ')}}
        </p>
        <ng-template #no_services>
            <p class="partnersFilterInfo fw-normal">
                <b>Focus Areas: </b>{{partner.focusAreas.join(', ')}}
            </p>
        </ng-template>
      <div id="fakeButton" class="d-flex justify-content-end text-primary mt-2">
        Click to see more details &#8594;
      </div>
    </div>
</div>
